import { useState, useEffect } from "react";
import Header from "../Components/Header";
import { Grid2 } from "@mui/material";
import axios from "axios";

import Footer from "../Components/Footer";


const Equipe = () => {
    const [equipe, setEquipe] = useState([]);

  
    useEffect(() => {
      axios.get(`https://api.sigmasystems.com.br/api/odontoluzzi/get-equipe`)
        .then((response) => {
            const data = response.data;

            if (Array.isArray(data)) {
                const sorted = [...data].sort((a, b) => a.name - b.name);
                setEquipe(sorted);
            }
        })
        .catch((error) => {
          console.error('Erro na requisição:', error);
        });
        
    },[]);

    return(
        <div className="container">
            <Header/>
            <div className="content">             
                <div className="eduContainer">
                    <div className="eduContent from-top">
                        <div className="subTitle">Equipe</div>
                        <div className="title depo">Conheça nossa equipe</div>
                        <div className="titleLine"/>                   
                    </div>
                </div>
                <div className="especContainer">
                    <Grid2 columns={{ xs:4, sm:8, md:12}} container spacing={2} justifyContent={'center'}>
                        <Grid2 item>
                            <Grid2 container justifyContent={'center'} className='from-bottom' spacing={3} width={'100%'} marginLeft={0}>
                                {equipe.map((equipe) => (
                                    <div className="equipeCard" style={{width:'350px'}} key={equipe.id}>
                                        {equipe.foto ? <img className="equipeFoto" style={{width:350, height:350}} src={`https://api.sigmasystems.com.br/api/odontoluzzi/uploads/equipe/${equipe.foto}`}/> : <img className="equipeFoto" style={{width:350, height:350}} src={"https://odontoluzzi.com.br/images/padrao/padraoEquipe.png"}/>}
                                        <div className="equipeName">{equipe.name || ''}</div>
                                        <div className="equipeTitle">{equipe.titulo}</div>
                                        {equipe.cro ? (<>
                                            <div className="equipeCro">CRO-{equipe.cro_uf} {equipe.cro}</div>
                                            <div className="titleLine" style={{width:90}}/> 
                                        </>
                                        ):('')}
                                    </div>
                                ))}    
                            </Grid2>                    
                        </Grid2>
                    </Grid2>
                </div>
                <div className="workContainer">
                    <div className="workContent from-bottom">
                        <div className="title" style={{color:'#fff'}}>Trabalhe Conosco</div>
                        <div className="titleLine"/>
                        <div className="workSubTitle">Venha fazer parte da nossa equipe!</div>
                        <div className="workLinks">
                            <a href='https://linkedin.com'><img src="https://odontoluzzi.com.br/images/linkedin.svg" className="linkedIn"/></a>
                            <a href='https://infojobs.com'><img src="https://odontoluzzi.com.br/images/ij.svg" className="infoJobs" style={{width:'33px'}}/></a>
                        </div>
                    </div>
                </div>
            </div>
            <Footer/>
        </div>
    )
}
export default Equipe;